import clsx from 'clsx';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import PropTypes from 'prop-types';

import 'dayjs/locale/fr';
import 'dayjs/locale/es';
dayjs.extend(utc);
dayjs.extend(timezone);

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Lib
import { calendarViews } from '@/lib/scheduler/calendar/calendar';

import Icon from '@/components/base/Icon';
import CreateSocialMediaEventModal from '@/components/pages/scheduler/calendar/social-media-events/CreateSocialMediaEventModal';

const DayHeader = ({ date, isPast, isToday, viewType, notEditable = false, locale = 'en' }) => {
    const { isOpen: isOpenCreateModal, toggle: toggleCreateModal } = useToggle();
    const dayTextFormat = dayjs(date).utc().locale(locale).format('ddd');

    if (viewType && viewType === calendarViews.month) {
        return (
            <div className="relative flex flex-col items-center space-y-1 p-4">
                <p className="text-9 capitalize text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {dayTextFormat}
                </p>
            </div>
        );
    }

    return (
        <div
            className={clsx(
                'group relative flex items-center justify-center space-x-1 p-[0.875rem] text-sm',
                {
                    'opacity-60': isPast
                }
            )}>
            {!notEditable && (
                <div className="absolute inset-0 z-1 hidden w-full p-1 group-hover:flex">
                    <button
                        onClick={toggleCreateModal}
                        className="flex w-full items-center justify-center rounded-m bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20">
                        <Icon icon="calendar-add" />
                    </button>
                </div>
            )}

            <span
                className={clsx('capitalize', {
                    'group-hover:invisible': !notEditable,
                    'text-icoBlue': isToday,
                    'text-icoBlack dark:text-white': !isToday
                })}>
                {dayTextFormat}
            </span>
            <span
                data-testid={isToday ? 'date-today' : 'other-day'}
                className={clsx({
                    'group-hover:invisible': !notEditable,
                    'text-icoBlue': isToday
                })}>
                {dayjs(date).utc().locale(locale).format('DD')}
            </span>
            {isToday ? (
                <span
                    className={clsx(
                        'absolute bottom-0 left-1/2 h-0.75 w-4 -translate-x-1/2 transform rounded-tl-lg rounded-tr-lg bg-icoBlue',
                        {
                            'group-hover:invisible': !notEditable
                        }
                    )}
                />
            ) : null}
            {!notEditable ? (
                <CreateSocialMediaEventModal
                    event={{
                        start_date: dayjs(date).utc().format('YYYY-MM-DD'),
                        end_date: dayjs(date).utc().format('YYYY-MM-DD')
                    }}
                    isOpen={isOpenCreateModal}
                    toggle={toggleCreateModal}
                />
            ) : null}
        </div>
    );
};

DayHeader.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    isPast: PropTypes.bool.isRequired,
    isToday: PropTypes.bool.isRequired,
    viewType: PropTypes.string.isRequired,
    notEditable: PropTypes.bool
};

export default DayHeader;
